import React, { useState, useEffect } from 'react';
import { api } from '../services/api';
import { FaTrash, FaCheck, FaUndo } from 'react-icons/fa';
import '../styles/TaskItem.css';

// Composant pour afficher une tâche (mode affichage ou édition)
function TaskItem({ task, cats, isEditing, setEditingTaskId, toggleTask, delTask, loadAll }) {
  // Champs pour le mode édition
  const [editTitle, setEditTitle] = useState(task.title);
  const [editDesc, setEditDesc] = useState(task.description || '');
  const [editPrio, setEditPrio] = useState(task.priority);
  const [editDate, setEditDate] = useState(task.due_date || '');
  const [editCats, setEditCats] = useState([]);

  // Charge les valeurs de la tâche quand on passe en mode édition
  useEffect(() => {
    if (isEditing) {
      setEditTitle(task.title);
      setEditDesc(task.description || '');
      setEditPrio(task.priority);
      setEditDate(task.due_date || '');
      // Parse les IDs de catégories (peuvent être string ou array)
      try {
        const taskCatIds = task.category_ids 
            ? (Array.isArray(task.category_ids) ? task.category_ids : JSON.parse(task.category_ids)) 
            : [];
        setEditCats(taskCatIds);
      } catch(e) { setEditCats([]); }
    }
  }, [isEditing, task]);

  // Ajoute/retire une catégorie en mode édition
  const toggleEditCat = (id) => {
    editCats.includes(id) ? setEditCats(editCats.filter(c=>c!==id)) : setEditCats([...editCats, id]);
  };

  // Sauvegarde les modifications de la tâche
  const saveEdit = async (e) => {
    e.preventDefault();
    if(editCats.length === 0) return alert("Choisissez au moins une catégorie");
    // Appel API pour mettre à jour
    await api.updateTask({ 
      id: task.id, title: editTitle, description: editDesc, 
      priority: editPrio, category_ids: editCats, due_date: editDate, status: task.status 
    });
    setEditingTaskId(null); // Quitte le mode édition
    loadAll(); // Recharge les tâches
  };

  if (isEditing) {
    return (
      <div className="task-edit-mode">
        <form onSubmit={saveEdit}>
          <input value={editTitle} onChange={e=>setEditTitle(e.target.value)} required placeholder="Titre..." />
          <textarea className="task-description" value={editDesc} onChange={e=>setEditDesc(e.target.value)} rows="3" placeholder="Description..." />
          
          <div className="form-row">
            <input type="date" value={editDate} onChange={e=>setEditDate(e.target.value)} />
            <select value={editPrio} onChange={e=>setEditPrio(e.target.value)}>
              <option value="low">Basse</option>
              <option value="medium">Moyenne</option>
              <option value="high">Haute</option>
            </select>
          </div>

          <div className="category-selector-container">
            <small>Catégories :</small>
            <div className="category-selector">
              {cats.map(c => (
                <div
                  key={c.id}
                  className={`category-chip ${editCats.includes(c.id) ? 'selected' : ''}`}
                  style={{ background: c.color }}
                  onClick={() => toggleEditCat(c.id)}
                >
                  {c.name}
                </div>
              ))}
            </div>
          </div>

          <div className="task-edit-actions">
            <button type="submit" className="btn-save">💾 Enregistrer</button>
            <button type="button" className="btn-cancel" onClick={()=>setEditingTaskId(null)}>✖ Annuler</button>
          </div>
        </form>
      </div>
    );
  }

  // Retourne le badge de priorité selon le niveau (low/medium/high)
  const getPriorityBadge = (priority) => {
    const badges = {
      low: { label: 'BASSE', className: 'priority-low' },
      medium: { label: 'MOYENNE', className: 'priority-medium' },
      high: { label: 'HAUTE', className: 'priority-high' }
    };
    const badge = badges[priority] || badges.medium;
    return <span className={`priority-badge ${badge.className}`}>{badge.label}</span>;
  };

  // Vérifie si la tâche est en retard (date passée et non terminée)
  const isOverdue = () => {
    if (!task.due_date || task.status === 'completed') return false;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const dueDate = new Date(task.due_date);
    dueDate.setHours(0, 0, 0, 0);
    return dueDate < today; // Retourne true si la date est passée
  };

  return (
    <div className="task-row" style={{opacity: task.status==='completed'?0.5:1}}>
      <div style={{flex: 1}}>
        <div style={{display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '5px'}}>
          <strong>{task.title}</strong>
          {getPriorityBadge(task.priority)}
          {isOverdue() && <span className="overdue-badge">⚠️ EN RETARD</span>}
        </div>
        {task.description && <div className="task-description-preview">{task.description}</div>}
        <small>{task.due_date} • {task.category_names}</small>
      </div>
      <div>
        <button onClick={()=>setEditingTaskId(task.id)}>✏️</button>
        <button onClick={()=>toggleTask(task)}>{task.status==='pending' ? <FaCheck/> : <FaUndo/>}</button>
        <button onClick={()=>delTask(task.id)}><FaTrash/></button>
      </div>
    </div>
  );
}

export default TaskItem;